module.exports = __webpack_public_path__ + "./images/p12.JPG?02acb290ee64dbe0a65841f200bcc7dc";


//////////////////
// WEBPACK FOOTER
// ./src/products/p12.JPG
// module id = 47
// module chunks = 0